import { render } from "./SearchAllProducts.vue?vue&type=template&id=40f55c66"
import script from "./SearchAllProducts.vue?vue&type=script&lang=js"
export * from "./SearchAllProducts.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2980638495/src/developer.gov.sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__